import { katTranslator } from '../../shared/i18n';

const strings = {
  'region-selector-placeholder': {
    'ar-AE': {
      param: '0',
      pluralItems: {
        zero: '{0,number,integer} بلدان/مناطق',
        one: 'بلد/منطقة ({0,number,integer})',
        two: 'بلدان/منطقتان ({0,number,integer})',
        few: '{0,number,integer} بلدان/مناطق',
        many: '{0,number,integer} بلدًا/منطقة',
        other: '{0,number,integer} بلد/منطقة',
      },
    },
    'bn-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} দেশ/অঞ্চল',
        other: '{0,number,integer} দেশ/অঞ্চলগুলি',
      },
    },
    'de-DE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer}Land/Region',
        other: '{0,number,integer}Länder/Regionen',
      },
    },
    'en-AU': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/region',
        other: '{0,number,integer} Countries/regions',
      },
    },
    'en-CA': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/region',
        other: '{0,number,integer} Countries/regions',
      },
    },
    'en-GB': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-SG': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/region',
        other: '{0,number,integer} Countries/regions',
      },
    },
    'en-US': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-ZA': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'es-ES': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} País o región',
        other: '{0,number,integer} Países o regiones',
        many: '{0,number,integer} Países o regiones',
      },
    },
    'es-MX': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} País o región',
        other: '{0,number,integer} Países o regiones',
        many: '{0,number,integer} Países o regiones',
      },
    },
    'fr-BE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} pays/région',
        other: '{0,number,integer} pays/régions',
        many: '{0,number,integer} pays/régions',
      },
    },
    'fr-FR': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Pays/région',
        other: '{0,number,integer} Pays/régions',
        many: '{0,number,integer} Pays/régions',
      },
    },
    'gu-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer}દેશ',
        other: '{0,number,integer} દેશો/પ્રદેશો',
      },
    },
    'hi-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} देश/क्षेत्र',
        other: '{0,number,integer} देश/क्षेत्र',
      },
    },
    'it-IT': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Paese/area geografica',
        many: '{0,number,integer} Paesi/aree geografiche',
        other: '{0,number,integer} Paesi/aree geografiche',
      },
    },
    'ja-JP': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer}国/地域',
      },
    },
    'kn-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} ದೇಶ/ಪ್ರಾಂತ್ಯ',
        other: '{0,number,integer} ದೇಶಗಳು/ವಲಯಗಳು',
      },
    },
    'ko-KR': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer} 국가/지역',
      },
    },
    'ml-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} രാജ്യം/പ്രദേശം',
        other: '{0,number,integer} രാജ്യങ്ങൾ/പ്രദേശങ്ങൾ',
      },
    },
    'mr-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} देश/प्रदेश',
        other: '{0,number,integer} देश/प्रदेश',
      },
    },
    'nl-BE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Land/regio',
        other: "{0,number,integer} Landen/regio''s",
      },
    },
    'nl-NL': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer}Land/regio',
        other: "{0,number,integer}Landen/regio''s",
      },
    },
    'pl-PL': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} kraj/region',
        few: '{0,number,integer} kraje/regiony',
        many: '{0,number,integer} krajów/regionów',
        other: '{0,number,integer} kraju/regionu',
      },
    },
    'pt-BR': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} País/Região',
        other: '{0,number,integer} Países/regiões',
        many: '{0,number,integer} Países/regiões',
      },
    },
    'pt-PT': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} País/região',
        other: '{0,number,integer} Países/Regiões',
        many: '{0,number,integer} Países/Regiões',
      },
    },
    'sv-SE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Land/region',
        other: '{0,number,integer} Länder/regioner',
      },
    },
    'ta-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} நாடு/பகுதி',
        other: '{0,number,integer} நாடுகள்/பகுதிகள்',
      },
    },
    'te-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} దేశం/ప్రాంతం',
        other: '{0,number,integer} దేశాలు/ప్రాంతాలు',
      },
    },
    'th-TH': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer} ประเทศ/ภูมิภาค',
      },
    },
    'tr-TR': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} ülke veya bölge',
        other: '{0,number,integer} ülke veya bölge',
      },
    },
    'vi-VN': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer} Quốc gia/Khu vực',
      },
    },
    'zh-CN': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer} 个国家/地区',
      },
    },
    'zh-TW': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer} 國家/地區',
      },
    },
  },
  'region-selector-americas': {
    'ar-AE': 'الأمريكتان',
    'bn-IN': 'আমেরিকা',
    'de-DE': 'Nord- und Südamerika',
    'en-AU': 'Americas',
    'en-CA': 'Americas',
    'en-GB': 'Americas',
    'en-IN': 'Americas',
    'en-SG': 'Americas',
    'en-US': 'Americas',
    'en-ZA': 'Americas',
    'es-ES': 'América',
    'es-MX': 'América',
    'fr-BE': 'Amériques',
    'fr-FR': 'Amériques',
    'gu-IN': 'અમેરિકા',
    'hi-IN': 'अमेरिका',
    'it-IT': 'Americhe',
    'ja-JP': '南北アメリカ大陸',
    'kn-IN': 'ಅಮೆರಿಕಾ',
    'ko-KR': '아메리카',
    'ml-IN': 'അമേരിക്കാസ്',
    'mr-IN': 'अमेरिकाज',
    'nl-BE': 'Noord- en Zuid-Amerika',
    'nl-NL': 'Noord- en Zuid-Amerika',
    'pl-PL': 'Ameryki',
    'pt-BR': 'Américas',
    'pt-PT': 'Américas',
    'sv-SE': 'Nord- och Sydamerika',
    'ta-IN': 'அமெரிக்க நாடுகள்',
    'te-IN': 'అమెరికాలు',
    'th-TH': 'ทวีปอเมริกา',
    'tr-TR': 'Kuzey ve Güney Amerika',
    'vi-VN': 'Châu Mỹ',
    'zh-CN': '美洲',
    'zh-TW': '美洲',
  },
  'region-selector-brazil': {
    'ar-AE': 'البرازيل',
    'bn-IN': 'ব্রাজিল',
    'de-DE': 'Brasilien',
    'en-AU': 'Brazil',
    'en-CA': 'Brazil',
    'en-GB': 'Brazil',
    'en-IN': 'Brazil',
    'en-SG': 'Brazil',
    'en-US': 'Brazil',
    'en-ZA': 'Brazil',
    'es-ES': 'Brasil',
    'es-MX': 'Brasil',
    'fr-BE': 'Brésil',
    'fr-FR': 'Brésil',
    'gu-IN': 'બ્રાઝિલ',
    'hi-IN': 'ब्राज़ील',
    'it-IT': 'Brasile',
    'ja-JP': 'ブラジル',
    'kn-IN': 'ಬ್ರೆಜಿಲ್',
    'ko-KR': '브라질',
    'ml-IN': 'ബ്രസീൽ',
    'mr-IN': 'ब्राझील',
    'nl-BE': 'Brazilië',
    'nl-NL': 'Brazilië',
    'pl-PL': 'Brazylia',
    'pt-BR': 'Brasil',
    'pt-PT': 'Brasil',
    'sv-SE': 'Brasilien',
    'ta-IN': 'பிரேசில்',
    'te-IN': 'బ్రెజిల్',
    'th-TH': 'บราซิล',
    'tr-TR': 'Brezilya',
    'vi-VN': 'Brazil',
    'zh-CN': '巴西',
    'zh-TW': '巴西',
  },
  'region-selector-canada': {
    'ar-AE': 'كندا',
    'bn-IN': 'কানাডা',
    'de-DE': 'Kanada',
    'en-AU': 'Canada',
    'en-CA': 'Canada',
    'en-GB': 'Canada',
    'en-IN': 'Canada',
    'en-SG': 'Canada',
    'en-US': 'Canada',
    'en-ZA': 'Canada',
    'es-ES': 'Canadá',
    'es-MX': 'Canadá',
    'fr-BE': 'Canada',
    'fr-FR': 'Canada',
    'gu-IN': 'કેનેડા',
    'hi-IN': 'कनाडा',
    'it-IT': 'Canada',
    'ja-JP': 'カナダ',
    'kn-IN': 'ಕೆನಡಾ',
    'ko-KR': '캐나다',
    'ml-IN': 'കാനഡ',
    'mr-IN': 'कॅनडा',
    'nl-BE': 'Canada',
    'nl-NL': 'Canada',
    'pl-PL': 'Kanada',
    'pt-BR': 'Canadá',
    'pt-PT': 'Canadá',
    'sv-SE': 'Kanada',
    'ta-IN': 'கனடா',
    'te-IN': 'కెనడా',
    'th-TH': 'แคนาดา',
    'tr-TR': 'Kanada',
    'vi-VN': 'Canada',
    'zh-CN': '加拿大',
    'zh-TW': '加拿大',
  },
  'region-selector-united-states': {
    'ar-AE': 'الولايات المتحدة',
    'bn-IN': 'মার্কিন যুক্তরাষ্ট্র',
    'de-DE': 'USA',
    'en-AU': 'United States',
    'en-CA': 'United States',
    'en-GB': 'United States',
    'en-IN': 'United States',
    'en-SG': 'United States',
    'en-US': 'United States',
    'en-ZA': 'United States',
    'es-ES': 'Estados Unidos',
    'es-MX': 'Estados Unidos',
    'fr-BE': 'États-Unis',
    'fr-FR': 'États-Unis',
    'gu-IN': 'યુનાઇટેડ સ્ટેટ્સ',
    'hi-IN': 'संयुक्त राज्य अमेरिका',
    'it-IT': 'Stati Uniti',
    'ja-JP': '米国',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಸ್ಟೇಟ್ಸ್',
    'ko-KR': '미국',
    'ml-IN': 'യുണൈറ്റഡ് സ്റ്റേറ്റ്സ്',
    'mr-IN': 'युनायटेड स्टेट्स',
    'nl-BE': 'Verenigde Staten',
    'nl-NL': 'Verenigde Staten',
    'pl-PL': 'Stany Zjednoczone',
    'pt-BR': 'Estados Unidos',
    'pt-PT': 'Estados Unidos',
    'sv-SE': 'USA',
    'ta-IN': 'ஐக்கிய அமெரிக்கா',
    'te-IN': 'యునైటెడ్ స్టేట్స్',
    'th-TH': 'สหรัฐอเมริกา',
    'tr-TR': 'Amerika Birleşik Devletleri',
    'vi-VN': 'Hoa Kỳ',
    'zh-CN': '美国',
    'zh-TW': '美國',
  },
  'region-selector-mexico': {
    'ar-AE': 'المكسيك',
    'bn-IN': 'মেক্সিকো',
    'de-DE': 'Mexiko',
    'en-AU': 'Mexico',
    'en-CA': 'Mexico',
    'en-GB': 'Mexico',
    'en-IN': 'Mexico',
    'en-SG': 'Mexico',
    'en-US': 'Mexico',
    'en-ZA': 'Mexico',
    'es-ES': 'México',
    'es-MX': 'México',
    'fr-BE': 'Mexique',
    'fr-FR': 'Mexique',
    'gu-IN': 'મેક્સિકો',
    'hi-IN': 'मेक्सिको',
    'it-IT': 'Messico',
    'ja-JP': 'メキシコ',
    'kn-IN': 'ಮೆಕ್ಸಿಕೊ',
    'ko-KR': '멕시코',
    'ml-IN': 'മെക്സിക്കോ',
    'mr-IN': 'मेक्सिको',
    'nl-BE': 'Mexico',
    'nl-NL': 'Mexico',
    'pl-PL': 'Meksyk',
    'pt-BR': 'México',
    'pt-PT': 'México',
    'sv-SE': 'Mexiko',
    'ta-IN': 'மெக்சிகோ',
    'te-IN': 'మెక్సికో',
    'th-TH': 'เม็กซิโก',
    'tr-TR': 'Meksika',
    'vi-VN': 'Mexico',
    'zh-CN': '墨西哥',
    'zh-TW': '墨西哥',
  },
  'region-selector-asia-pacific': {
    'ar-AE': 'آسيا والمحيط الهادئ',
    'bn-IN': 'এশিয়া-প্যাসিফিক',
    'de-DE': 'Asien-Pazifik',
    'en-AU': 'Asia-Pacific',
    'en-CA': 'Asia-Pacific',
    'en-GB': 'Asia-Pacific',
    'en-IN': 'Asia-pacific',
    'en-SG': 'Asia-Pacific',
    'en-US': 'Asia-pacific',
    'en-ZA': 'Asia-pacific',
    'es-ES': 'Asia y el Pacífico',
    'es-MX': 'Asia-Pacífico',
    'fr-BE': 'Asie-Pacifique',
    'fr-FR': 'Asie-Pacifique',
    'gu-IN': 'એશિયા-પેસિફિક',
    'hi-IN': 'एशिया-पैसिफ़िक',
    'it-IT': 'Asia/Pacifico',
    'ja-JP': 'アジア太平洋',
    'kn-IN': 'ಏಷ್ಯಾ- ಪೆಸಿಫಿಕ್',
    'ko-KR': '아시아 태평양',
    'ml-IN': 'ഏഷ്യാ-പസഫിക്',
    'mr-IN': 'आशिया-पॅसिफिक',
    'nl-BE': 'Azië/Stille Oceaan',
    'nl-NL': 'Azië-Pacific',
    'pl-PL': 'Azja i Pacyfik',
    'pt-BR': 'Ásia-Pacífico',
    'pt-PT': 'Ásia-Pacífico',
    'sv-SE': 'Asien-Stillahavsområdet',
    'ta-IN': 'ஆசியா-பசிபிக்',
    'te-IN': 'ఆసియా-పసిఫిక్',
    'th-TH': 'เอเชียแปซิฟิก',
    'tr-TR': 'Asya-Pasifik',
    'vi-VN': 'Châu Á Thái Bình Dương',
    'zh-CN': '亚太地区',
    'zh-TW': '亞太地區',
  },
  'region-selector-australia': {
    'ar-AE': 'أستراليا',
    'bn-IN': 'অস্ট্রেলিয়া',
    'de-DE': 'Australien',
    'en-AU': 'Australia',
    'en-CA': 'Australia',
    'en-GB': 'Australia',
    'en-IN': 'Australia',
    'en-SG': 'Australia',
    'en-US': 'Australia',
    'en-ZA': 'Australia',
    'es-ES': 'Australia',
    'es-MX': 'Australia',
    'fr-BE': 'Australie',
    'fr-FR': 'Australie',
    'gu-IN': 'ઓસ્ટ્રેલિયા',
    'hi-IN': 'ऑस्ट्रेलिया',
    'it-IT': 'Australia',
    'ja-JP': 'オーストラリア',
    'kn-IN': 'ಆಸ್ಟ್ರೇಲಿಯಾ',
    'ko-KR': '오스트레일리아',
    'ml-IN': 'ആസ്ട്രേലിയ',
    'mr-IN': 'ऑस्ट्रेलिया',
    'nl-BE': 'Australië',
    'nl-NL': 'Australië',
    'pl-PL': 'Australia',
    'pt-BR': 'Austrália',
    'pt-PT': 'Austrália',
    'sv-SE': 'Australien',
    'ta-IN': 'ஆஸ்திரேலியா',
    'te-IN': 'ఆస్ట్రేలియా',
    'th-TH': 'ออสเตรเลีย',
    'tr-TR': 'Avustralya',
    'vi-VN': 'Úc',
    'zh-CN': '澳大利亚',
    'zh-TW': '澳洲',
  },
  'region-selector-india': {
    'ar-AE': 'الهند',
    'bn-IN': 'ভারত',
    'de-DE': 'Indien',
    'en-AU': 'India',
    'en-CA': 'India',
    'en-GB': 'India',
    'en-IN': 'India',
    'en-SG': 'India',
    'en-US': 'India',
    'en-ZA': 'India',
    'es-ES': 'India',
    'es-MX': 'India',
    'fr-BE': 'Inde',
    'fr-FR': 'Inde',
    'gu-IN': 'ભારત',
    'hi-IN': 'भारत',
    'it-IT': 'India',
    'ja-JP': 'インド',
    'kn-IN': 'ಭಾರತ',
    'ko-KR': '인도',
    'ml-IN': 'ഇന്ത്യ',
    'mr-IN': 'भारत',
    'nl-BE': 'India',
    'nl-NL': 'India',
    'pl-PL': 'Indie',
    'pt-BR': 'Índia',
    'pt-PT': 'Índia',
    'sv-SE': 'Indien',
    'ta-IN': 'இந்தியா',
    'te-IN': 'భారతదేశం',
    'th-TH': 'อินเดีย',
    'tr-TR': 'Hindistan',
    'vi-VN': 'Ấn Độ',
    'zh-CN': '印度',
    'zh-TW': '印度',
  },
  'region-selector-japan': {
    'ar-AE': 'اليابان',
    'bn-IN': 'জাপান',
    'de-DE': 'Japan',
    'en-AU': 'Japan',
    'en-CA': 'Japan',
    'en-GB': 'Japan',
    'en-IN': 'Japan',
    'en-SG': 'Japan',
    'en-US': 'Japan',
    'en-ZA': 'Japan',
    'es-ES': 'Japón',
    'es-MX': 'Japón',
    'fr-BE': 'Japon',
    'fr-FR': 'Japon',
    'gu-IN': 'જાપાન',
    'hi-IN': 'जापान',
    'it-IT': 'Giappone',
    'ja-JP': '日本',
    'kn-IN': 'ಜಪಾನ್',
    'ko-KR': '일본',
    'ml-IN': 'ജപ്പാൻ',
    'mr-IN': 'जपान',
    'nl-BE': 'Japan',
    'nl-NL': 'Japan',
    'pl-PL': 'Japonia',
    'pt-BR': 'Japão',
    'pt-PT': 'Japão',
    'sv-SE': 'Japan',
    'ta-IN': 'ஜப்பான்',
    'te-IN': 'జపాన్',
    'th-TH': 'ญี่ปุ่น',
    'tr-TR': 'Japonya',
    'vi-VN': 'Nhật Bản',
    'zh-CN': '日本',
    'zh-TW': '日本',
  },
  'region-selector-singapore': {
    'ar-AE': 'سنغافورة',
    'bn-IN': 'সিঙ্গাপুর',
    'de-DE': 'Singapur',
    'en-AU': 'Singapore',
    'en-CA': 'Singapore',
    'en-GB': 'Singapore',
    'en-IN': 'Singapore',
    'en-SG': 'Singapore',
    'en-US': 'Singapore',
    'en-ZA': 'Singapore',
    'es-ES': 'Singapur',
    'es-MX': 'Singapur',
    'fr-BE': 'Singapour',
    'fr-FR': 'Singapour',
    'gu-IN': 'સિંગાપુર',
    'hi-IN': 'सिंगापुर',
    'it-IT': 'Singapore',
    'ja-JP': 'シンガポール',
    'kn-IN': 'ಸಿಂಗಾಪುರ',
    'ko-KR': '싱가포르',
    'ml-IN': 'സിംഗപ്പൂർ',
    'mr-IN': 'सिंगापूर',
    'nl-BE': 'Singapore',
    'nl-NL': 'Singapore',
    'pl-PL': 'Singapur',
    'pt-BR': 'Singapura',
    'pt-PT': 'Singapura',
    'sv-SE': 'Singapore',
    'ta-IN': 'சிங்கப்பூர்',
    'te-IN': 'సింగపూర్',
    'th-TH': 'สิงคโปร์',
    'tr-TR': 'Singapur',
    'vi-VN': 'Singapore',
    'zh-CN': '新加坡',
    'zh-TW': '新加坡',
  },
  'region-selector-europe': {
    'ar-AE': 'أوروبا',
    'bn-IN': 'ইউরোপ',
    'de-DE': 'Europa',
    'en-AU': 'Europe',
    'en-CA': 'Europe',
    'en-GB': 'Europe',
    'en-IN': 'Europe',
    'en-SG': 'Europe',
    'en-US': 'Europe',
    'en-ZA': 'Europe',
    'es-ES': 'Europa',
    'es-MX': 'Europa',
    'fr-BE': 'Europe',
    'fr-FR': 'Europe',
    'gu-IN': 'યુરોપ',
    'hi-IN': 'यूरोप',
    'it-IT': 'Europa',
    'ja-JP': 'ヨーロッパ',
    'kn-IN': 'ಯೂರೋಪ್‌',
    'ko-KR': '유럽',
    'ml-IN': 'യൂറോപ്പ്',
    'mr-IN': 'युरोप',
    'nl-BE': 'Europa',
    'nl-NL': 'Europa',
    'pl-PL': 'Europa',
    'pt-BR': 'Europa',
    'pt-PT': 'Europa',
    'sv-SE': 'Europa',
    'ta-IN': 'ஐரோப்பா',
    'te-IN': 'యూరోప్',
    'th-TH': 'ยุโรป',
    'tr-TR': 'Avrupa',
    'vi-VN': 'Châu Âu',
    'zh-CN': '欧洲',
    'zh-TW': '歐洲',
  },
  'region-selector-belgium': {
    'ar-AE': 'بلجيكا',
    'bn-IN': 'বেলজিয়াম',
    'de-DE': 'Belgien',
    'en-AU': 'Belgium',
    'en-CA': 'Belgium',
    'en-GB': 'Belgium',
    'en-IN': 'Belgium',
    'en-SG': 'Belgium',
    'en-US': 'Belgium',
    'en-ZA': 'Belgium',
    'es-ES': 'Bélgica',
    'es-MX': 'Bélgica',
    'fr-BE': 'Belgique',
    'fr-FR': 'Belgique',
    'gu-IN': 'બેલ્જિયમ',
    'hi-IN': 'बेल्जियम',
    'it-IT': 'Belgio',
    'ja-JP': 'ベルギー',
    'kn-IN': 'ಬೆಲ್ಜಿಯಂ',
    'ko-KR': '벨기에',
    'ml-IN': 'ബെൽജിയം',
    'mr-IN': 'बेल्जियम',
    'nl-BE': 'België',
    'nl-NL': 'België',
    'pl-PL': 'Belgia',
    'pt-BR': 'Bélgica',
    'pt-PT': 'Bélgica',
    'sv-SE': 'Belgien',
    'ta-IN': 'பெல்ஜியம்',
    'te-IN': 'బెల్జియం',
    'th-TH': 'เบลเยียม',
    'tr-TR': 'Belçika',
    'vi-VN': 'Bỉ',
    'zh-CN': '比利时',
    'zh-TW': '比利時',
  },
  'region-selector-france': {
    'ar-AE': 'فرنسا',
    'bn-IN': 'ফ্রান্স',
    'de-DE': 'Frankreich',
    'en-AU': 'France',
    'en-CA': 'France',
    'en-GB': 'France',
    'en-IN': 'France',
    'en-SG': 'France',
    'en-US': 'France',
    'en-ZA': 'France',
    'es-ES': 'Francia',
    'es-MX': 'Francia',
    'fr-BE': 'France',
    'fr-FR': 'France',
    'gu-IN': 'ફ્રાન્સ',
    'hi-IN': 'फ़्रांस',
    'it-IT': 'Francia',
    'ja-JP': 'フランス',
    'kn-IN': 'ಫ್ರಾನ್ಸ್‌',
    'ko-KR': '프랑스',
    'ml-IN': 'ഫ്രാൻസ്',
    'mr-IN': 'फ्रान्स',
    'nl-BE': 'Frankrijk',
    'nl-NL': 'Frankrijk',
    'pl-PL': 'Francja',
    'pt-BR': 'França',
    'pt-PT': 'França',
    'sv-SE': 'Frankrike',
    'ta-IN': 'பிரான்சு',
    'te-IN': 'ఫ్రాన్స్',
    'th-TH': 'ฝรั่งเศส',
    'tr-TR': 'Fransa',
    'vi-VN': 'Pháp',
    'zh-CN': '法国',
    'zh-TW': '法國',
  },
  'region-selector-germany': {
    'ar-AE': 'ألمانيا',
    'bn-IN': 'জার্মানি',
    'de-DE': 'Deutschland',
    'en-AU': 'Germany',
    'en-CA': 'Germany',
    'en-GB': 'Germany',
    'en-IN': 'Germany',
    'en-SG': 'Germany',
    'en-US': 'Germany',
    'en-ZA': 'Germany',
    'es-ES': 'Alemania',
    'es-MX': 'Alemania',
    'fr-BE': 'Allemagne',
    'fr-FR': 'Allemagne',
    'gu-IN': 'જર્મની',
    'hi-IN': 'जर्मनी',
    'it-IT': 'Germania',
    'ja-JP': 'ドイツ',
    'kn-IN': 'ಜರ್ಮನಿ',
    'ko-KR': '독일',
    'ml-IN': 'ജർമ്മനി',
    'mr-IN': 'जर्मनी',
    'nl-BE': 'Duitsland',
    'nl-NL': 'Duitsland',
    'pl-PL': 'Niemcy',
    'pt-BR': 'Alemanha',
    'pt-PT': 'Alemanha',
    'sv-SE': 'Tyskland',
    'ta-IN': 'ஜெர்மனி',
    'te-IN': 'జర్మనీ',
    'th-TH': 'เยอรมนี',
    'tr-TR': 'Almanya',
    'vi-VN': 'Đức',
    'zh-CN': '德国',
    'zh-TW': '德國',
  },
  'region-selector-italy': {
    'ar-AE': 'إيطاليا',
    'bn-IN': 'ইতালি',
    'de-DE': 'Italien',
    'en-AU': 'Italy',
    'en-CA': 'Italy',
    'en-GB': 'Italy',
    'en-IN': 'Italy',
    'en-SG': 'Italy',
    'en-US': 'Italy',
    'en-ZA': 'Italy',
    'es-ES': 'Italia',
    'es-MX': 'Italia',
    'fr-BE': 'Italie',
    'fr-FR': 'Italie',
    'gu-IN': 'ઇટલી',
    'hi-IN': 'इटली',
    'it-IT': 'Italia',
    'ja-JP': 'イタリア',
    'kn-IN': 'ಇಟಲಿ',
    'ko-KR': '이탈리아',
    'ml-IN': 'ഇറ്റലി',
    'mr-IN': 'इटली',
    'nl-BE': 'Italië',
    'nl-NL': 'Italië',
    'pl-PL': 'Włochy',
    'pt-BR': 'Itália',
    'pt-PT': 'Itália',
    'sv-SE': 'Italien',
    'ta-IN': 'இத்தாலி',
    'te-IN': 'ఇటలీ',
    'th-TH': 'อิตาลี',
    'tr-TR': 'İtalya',
    'vi-VN': 'Ý',
    'zh-CN': '意大利',
    'zh-TW': '義大利',
  },
  'region-selector-netherlands': {
    'ar-AE': 'هولندا',
    'bn-IN': 'নেদারল্যান্ডস',
    'de-DE': 'Niederlande',
    'en-AU': 'Netherlands',
    'en-CA': 'Netherlands',
    'en-GB': 'Netherlands',
    'en-IN': 'Netherlands',
    'en-SG': 'Netherlands',
    'en-US': 'Netherlands',
    'en-ZA': 'Netherlands',
    'es-ES': 'Países Bajos',
    'es-MX': 'Países Bajos',
    'fr-BE': 'Pays-Bas',
    'fr-FR': 'Pays-Bas',
    'gu-IN': 'નેધરલેન્ડ',
    'hi-IN': 'नीदरलैंड',
    'it-IT': 'Paesi Bassi',
    'ja-JP': 'オランダ',
    'kn-IN': 'ನೆದರ್‌ಲ್ಯಾಂಡ್ಸ್‌',
    'ko-KR': '네덜란드',
    'ml-IN': 'നെതർലൻഡ്‌സ്',
    'mr-IN': 'नेदरलँड्स',
    'nl-BE': 'Nederland',
    'nl-NL': 'Nederland',
    'pl-PL': 'Holandia',
    'pt-BR': 'Países Baixos',
    'pt-PT': 'Países Baixos',
    'sv-SE': 'Nederländerna',
    'ta-IN': 'நெதர்லாந்து',
    'te-IN': 'నెదర్లాండ్స్',
    'th-TH': 'เนเธอร์แลนด์',
    'tr-TR': 'Hollanda',
    'vi-VN': 'Hà Lan',
    'zh-CN': '荷兰',
    'zh-TW': '荷蘭',
  },
  'region-selector-poland': {
    'ar-AE': 'بولندا',
    'bn-IN': 'পোল্যান্ড',
    'de-DE': 'Polen',
    'en-AU': 'Poland',
    'en-CA': 'Poland',
    'en-GB': 'Poland',
    'en-IN': 'Poland',
    'en-SG': 'Poland',
    'en-US': 'Poland',
    'en-ZA': 'Poland',
    'es-ES': 'Polonia',
    'es-MX': 'Polonia',
    'fr-BE': 'Pologne',
    'fr-FR': 'Pologne',
    'gu-IN': 'પોલેન્ડ',
    'hi-IN': 'पोलैंड',
    'it-IT': 'Polonia',
    'ja-JP': 'ポーランド',
    'kn-IN': 'ಪೋಲೆಂಡ್',
    'ko-KR': '폴란드',
    'ml-IN': 'പോളണ്ട്',
    'mr-IN': 'पोलंड',
    'nl-BE': 'Polen',
    'nl-NL': 'Polen',
    'pl-PL': 'Polska',
    'pt-BR': 'Polônia',
    'pt-PT': 'Polónia',
    'sv-SE': 'Polen',
    'ta-IN': 'போலந்து',
    'te-IN': 'పోలాండ్',
    'th-TH': 'โปแลนด์',
    'tr-TR': 'Polonya',
    'vi-VN': 'Ba Lan',
    'zh-CN': '波兰',
    'zh-TW': '波蘭',
  },
  'region-selector-spain': {
    'ar-AE': 'إسبانيا',
    'bn-IN': 'স্পেন',
    'de-DE': 'Spanien',
    'en-AU': 'Spain',
    'en-CA': 'Spain',
    'en-GB': 'Spain',
    'en-IN': 'Spain',
    'en-SG': 'Spain',
    'en-US': 'Spain',
    'en-ZA': 'Spain',
    'es-ES': 'España',
    'es-MX': 'España',
    'fr-BE': 'Espagne',
    'fr-FR': 'Espagne',
    'gu-IN': 'સ્પેઇન',
    'hi-IN': 'स्पेन',
    'it-IT': 'Spagna',
    'ja-JP': 'スペイン',
    'kn-IN': 'ಸ್ಪೇನ್‌',
    'ko-KR': '스페인',
    'ml-IN': 'സ്പെയിൻ',
    'mr-IN': 'स्पेन',
    'nl-BE': 'Spanje',
    'nl-NL': 'Spanje',
    'pl-PL': 'Hiszpania',
    'pt-BR': 'Espanha',
    'pt-PT': 'Espanha',
    'sv-SE': 'Spanien',
    'ta-IN': 'ஸ்பெயின்',
    'te-IN': 'స్పెయిన్',
    'th-TH': 'สเปน',
    'tr-TR': 'İspanya',
    'vi-VN': 'Tây Ban Nha',
    'zh-CN': '西班牙',
    'zh-TW': '西班牙',
  },
  'region-selector-sweden': {
    'ar-AE': 'السويد',
    'bn-IN': 'সুইডেন',
    'de-DE': 'Schweden',
    'en-AU': 'Sweden',
    'en-CA': 'Sweden',
    'en-GB': 'Sweden',
    'en-IN': 'Sweden',
    'en-SG': 'Sweden',
    'en-US': 'Sweden',
    'en-ZA': 'Sweden',
    'es-ES': 'Suecia',
    'es-MX': 'Suecia',
    'fr-BE': 'Suède',
    'fr-FR': 'Suède',
    'gu-IN': 'સ્વિડન',
    'hi-IN': 'स्वीडन',
    'it-IT': 'Svezia',
    'ja-JP': 'スウェーデン',
    'kn-IN': 'ಸ್ವೀಡನ್',
    'ko-KR': '스웨덴',
    'ml-IN': 'സ്വീഡൻ',
    'mr-IN': 'स्वीडन',
    'nl-BE': 'Zweden',
    'nl-NL': 'Zweden',
    'pl-PL': 'Szwecja',
    'pt-BR': 'Suécia',
    'pt-PT': 'Suécia',
    'sv-SE': 'Sverige',
    'ta-IN': 'சுவீடன்',
    'te-IN': 'స్వీడన్',
    'th-TH': 'สวีเดน',
    'tr-TR': 'İsveç',
    'vi-VN': 'Thụy Điển',
    'zh-CN': '瑞典',
    'zh-TW': '瑞典',
  },
  'region-selector-turkey': {
    'ar-AE': 'تركيا',
    'bn-IN': 'তুরস্ক',
    'de-DE': 'Türkei',
    'en-AU': 'Turkey',
    'en-CA': 'Turkey',
    'en-GB': 'Turkey',
    'en-IN': 'Turkey',
    'en-SG': 'Turkey',
    'en-US': 'Turkey',
    'en-ZA': 'Turkey',
    'es-ES': 'Turquía',
    'es-MX': 'Turquía',
    'fr-BE': 'Turquie',
    'fr-FR': 'Turquie',
    'gu-IN': 'તુર્કી',
    'hi-IN': 'तुर्की',
    'it-IT': 'Turchia',
    'ja-JP': 'トルコ',
    'kn-IN': 'ಟರ್ಕಿ',
    'ko-KR': '터키',
    'ml-IN': 'തുർക്കി',
    'mr-IN': 'तुर्की',
    'nl-BE': 'Turkije',
    'nl-NL': 'Turkije',
    'pl-PL': 'Turcja',
    'pt-BR': 'Turquia',
    'pt-PT': 'Turquia',
    'sv-SE': 'Turkiet',
    'ta-IN': 'துருக்கி',
    'te-IN': 'టర్కీ',
    'th-TH': 'ตุรกี',
    'tr-TR': 'Türkiye',
    'vi-VN': 'Thổ Nhĩ Kỳ',
    'zh-CN': '土耳其',
    'zh-TW': '土耳其',
  },
  'region-selector-united-kingdom': {
    'ar-AE': 'المملكة المتحدة',
    'bn-IN': 'যুক্তরাজ্য',
    'de-DE': 'Vereinigtes Königreich',
    'en-AU': 'United Kingdom',
    'en-CA': 'United Kingdom',
    'en-GB': 'United Kingdom',
    'en-IN': 'United Kingdom',
    'en-SG': 'United Kingdom',
    'en-US': 'United Kingdom',
    'en-ZA': 'United Kingdom',
    'es-ES': 'Reino Unido',
    'es-MX': 'Reino Unido',
    'fr-BE': 'Royaume-Uni',
    'fr-FR': 'Royaume-Uni',
    'gu-IN': 'યુનાઇટેડ કિંગ્ડમ',
    'hi-IN': 'यूनाइटेड किंगडम',
    'it-IT': 'Regno Unito',
    'ja-JP': 'イギリス',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಕಿಂಗ್‌ಡಮ್',
    'ko-KR': '영국',
    'ml-IN': 'യുണൈറ്റഡ് കിംഗ്‌ഡം',
    'mr-IN': 'युनायटेड किंगडम',
    'nl-BE': 'Verenigd Koninkrijk',
    'nl-NL': 'Verenigd Koninkrijk',
    'pl-PL': 'Zjednoczone Królestwo',
    'pt-BR': 'Reino Unido',
    'pt-PT': 'Reino Unido',
    'sv-SE': 'Förenade kungariket',
    'ta-IN': 'ஐக்கிய இராச்சியம்',
    'te-IN': 'యునైటెడ్ కింగ్‍‌‍డమ్',
    'th-TH': 'สหราชอาณาจักร',
    'tr-TR': 'Birleşik Krallık',
    'vi-VN': 'Vương quốc Anh',
    'zh-CN': '英国',
    'zh-TW': '英國',
  },
  'region-selector-middle-east-and-north-africa': {
    'ar-AE': 'الشرق الأوسط وشمال أفريقيا',
    'bn-IN': 'মধ্যপ্রাচ্য ও উত্তর আফ্রিকা',
    'de-DE': 'Naher Osten und Nordafrika',
    'en-AU': 'Middle-East and North Africa',
    'en-CA': 'Middle-East and North Africa',
    'en-GB': 'Middle East and North Africa',
    'en-IN': 'Middle-east and North Africa',
    'en-SG': 'Middle-East and North Africa',
    'en-US': 'Middle-east and North Africa',
    'en-ZA': 'Middle-east and North Africa',
    'es-ES': 'Oriente Medio y África del Norte',
    'es-MX': 'Medio Oriente y Norte de África',
    'fr-BE': 'Moyen-Orient et Afrique du Nord',
    'fr-FR': 'Moyen-Orient et Afrique du Nord',
    'gu-IN': 'મધ્ય-પૂર્વ અને ઉત્તર આફ્રિકા',
    'hi-IN': 'मध्य पूर्व और उत्तरी अफ़्रीका',
    'it-IT': 'Medio Oriente e Nord Africa',
    'ja-JP': '中東および北アフリカ',
    'kn-IN': 'ಮಿಡಲ್‌ ಈಸ್ಟ್‌ ಮತ್ತು ನಾರ್ಥ್ ಆಫ್ರಿಕಾ',
    'ko-KR': '중동 및 북아프리카',
    'ml-IN': 'മിഡിൽ-ഈസ്റ്റ്, വടക്കേ ആഫ്രിക്ക',
    'mr-IN': 'मध्य-पूर्व आणि उत्तर आफ्रिका',
    'nl-BE': 'Midden-Oosten en Noord-Afrika',
    'nl-NL': 'Midden-Oosten en Noord-Afrika',
    'pl-PL': 'Bliski Wschód i Afryka Północna',
    'pt-BR': 'Oriente Médio e Norte da África',
    'pt-PT': 'Médio Oriente e Norte de África',
    'sv-SE': 'Mellanöstern och Nordafrika',
    'ta-IN': 'மத்திய கிழக்கு மற்றும் வட ஆப்பிரிக்கா',
    'te-IN': 'మిడిల్ ఈస్ట్ మరియు ఉత్తర ఆఫ్రికా',
    'th-TH': 'ภาคตะวันออกกลางและแอฟริกาเหนือ',
    'tr-TR': 'Orta Doğu ve Kuzey Afrika',
    'vi-VN': 'Trung Đông và Bắc Phi',
    'zh-CN': '中东和北非',
    'zh-TW': '中東和北非',
  },
  'region-selector-egypt': {
    'ar-AE': 'مصر',
    'bn-IN': 'মিশর',
    'de-DE': 'Ägypten',
    'en-AU': 'Egypt',
    'en-CA': 'Egypt',
    'en-GB': 'Egypt',
    'en-IN': 'Egypt',
    'en-SG': 'Egypt',
    'en-US': 'Egypt',
    'en-ZA': 'Egypt',
    'es-ES': 'Egipto',
    'es-MX': 'Egipto',
    'fr-BE': 'Égypte',
    'fr-FR': 'Égypte',
    'gu-IN': 'ઇજિપ્ત',
    'hi-IN': 'मिस्र',
    'it-IT': 'Egitto',
    'ja-JP': 'エジプト',
    'kn-IN': 'ಈಜಿಪ್ಟ್',
    'ko-KR': '이집트',
    'ml-IN': 'ഈജിപ്ത്',
    'mr-IN': 'इजिप्त',
    'nl-BE': 'Egypte',
    'nl-NL': 'Egypte',
    'pl-PL': 'Egipt',
    'pt-BR': 'Egito',
    'pt-PT': 'Egito',
    'sv-SE': 'Egypten',
    'ta-IN': 'எகிப்து',
    'te-IN': 'ఈజిప్ట్',
    'th-TH': 'อียิปต์',
    'tr-TR': 'Mısır',
    'vi-VN': 'Ai Cập',
    'zh-CN': '埃及',
    'zh-TW': '埃及',
  },
  'region-selector-saudi-arabia': {
    'ar-AE': 'المملكة العربية السعودية',
    'bn-IN': 'সৌদি আরব',
    'de-DE': 'Saudi-Arabien',
    'en-AU': 'Saudi Arabia',
    'en-CA': 'Saudi Arabia',
    'en-GB': 'Saudi Arabia',
    'en-IN': 'Saudi Arabia',
    'en-SG': 'Saudi Arabia',
    'en-US': 'Saudi Arabia',
    'en-ZA': 'Saudi Arabia',
    'es-ES': 'Arabia Saudí',
    'es-MX': 'Arabia Saudita',
    'fr-BE': 'Arabie saoudite',
    'fr-FR': 'Arabie saoudite',
    'gu-IN': 'સાઉદી અરેબિયા',
    'hi-IN': 'सऊदी अरब',
    'it-IT': 'Arabia Saudita',
    'ja-JP': 'サウジアラビア',
    'kn-IN': 'ಸೌದಿ ಅರೇಬಿಯಾ',
    'ko-KR': '사우디아라비아',
    'ml-IN': 'സൗദി അറേബ്യ',
    'mr-IN': 'सौदी अरेबिया',
    'nl-BE': 'Saoedi-Arabië',
    'nl-NL': 'Saoedi-Arabië',
    'pl-PL': 'Arabia Saudyjska',
    'pt-BR': 'Arábia Saudita',
    'pt-PT': 'Arábia Saudita',
    'sv-SE': 'Saudiarabien',
    'ta-IN': 'சவுதி அரேபியா',
    'te-IN': 'సౌదీ అరేబియా',
    'th-TH': 'ซาอุดีอาระเบีย',
    'tr-TR': 'Suudi Arabistan',
    'vi-VN': 'Ả Rập Xê Út',
    'zh-CN': '沙特阿拉伯',
    'zh-TW': '沙烏地阿拉伯',
  },
  'region-selector-united-arab-emirates': {
    'ar-AE': 'الإمارات العربية المتحدة',
    'bn-IN': 'সংযুক্ত আরব আমিরাত',
    'de-DE': 'Vereinigte Arabische Emirate',
    'en-AU': 'United Arab Emirates',
    'en-CA': 'United Arab Emirates',
    'en-GB': 'United Arab Emirates',
    'en-IN': 'United Arab Emirates',
    'en-SG': 'United Arab Emirates',
    'en-US': 'United Arab Emirates',
    'en-ZA': 'United Arab Emirates',
    'es-ES': 'Emiratos Árabes Unidos',
    'es-MX': 'Emiratos Árabes Unidos',
    'fr-BE': 'Émirats arabes unis',
    'fr-FR': 'Émirats arabes unis',
    'gu-IN': 'યુનાઇટેડ આરબ અમીરાત',
    'hi-IN': 'संयुक्त अरब अमीरात',
    'it-IT': 'Emirati Arabi Uniti',
    'ja-JP': 'アラブ首長国連邦',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಅರಬ್ ಎಮಿರೇಟ್ಸ್',
    'ko-KR': '아랍 에미리트 연합국',
    'ml-IN': 'യുണൈറ്റഡ് അറബ് എമിറേറ്റ്‌സ്',
    'mr-IN': 'युनायटेड अरब अमिरात',
    'nl-BE': 'Verenigde Arabische Emiraten',
    'nl-NL': 'Verenigde Arabische Emiraten',
    'pl-PL': 'Zjednoczone Emiraty Arabskie',
    'pt-BR': 'Emirados Árabes Unidos',
    'pt-PT': 'Emirados Árabes Unidos',
    'sv-SE': 'Förenade Arabemiraten',
    'ta-IN': 'ஐக்கிய அரபு அமீரகம்',
    'te-IN': 'యునైటెడ్ అరబ్ ఎమిరేట్స్',
    'th-TH': 'สหรัฐอาหรับเอมิเรตส์',
    'tr-TR': 'Birleşik Arap Emirlikleri',
    'vi-VN': 'Các Tiểu Vương Quốc Ả Rập Thống Nhất',
    'zh-CN': '阿联酋',
    'zh-TW': '阿拉伯聯合大公國',
  },
};

export default katTranslator(strings);
